import iconCurrencyRub from '../assets/images/icons/currency-rub.svg';

const DEFAULT_LANGUAGE = 'ru-RU';
const CURRENCY_SYMBOLS = {
    'RUR': { text: '₽', icon: iconCurrencyRub },
    'RUB': { text: '₽', icon: iconCurrencyRub },
    'р.': { text: '₽', icon: iconCurrencyRub },
};
const replaces = Object.keys(CURRENCY_SYMBOLS);

const getFloat = value => {
    return Number(parseFloat(value).toFixed(2));
};

export const baseCurrency = number => {
    const string = String(number);
    const [first, last] = string.split('.');
    const formatted = first.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (!last) {
        return formatted.trim();
    }
    return `${formatted}.${last}`.trim();
};

export const getCurrencyIcon = (currency) => {
    if (!currency) {
        return null;
    }
    return (CURRENCY_SYMBOLS[currency] || {})?.icon;
};
export const getCurrencyText = (currency) => {
    if (!currency) {
        return CURRENCY_SYMBOLS['RUB'].text;
    }
    return (CURRENCY_SYMBOLS[currency] || {}).text || currency;
};

export const currencyAsString = (value, currencyId, context = {}) => {
    if (!currencyId) {
        return baseCurrency(getFloat(value));
    }
    try {
        let result = new Intl.NumberFormat(navigator.language || DEFAULT_LANGUAGE, {
            style: 'currency',
            currency: currencyId,
            minimumFractionDigits: context.$configuration?.minimumFractionDigits,
        }).format(value);
        replaces.forEach(key => {
            result = result.replace(key, (CURRENCY_SYMBOLS[key] || {}).text || '');
        });
        if (context.$configuration?.minimumFractionDigits === 0) {
            return result;
        } else {
            const curIcon = result[result.length - 1];
            result = result.replace(curIcon, '').split(',');
            result.push(curIcon);
            return result;
        }
    } catch (error) {
        try {
            if (CURRENCY_SYMBOLS[currencyId]) {
                return `${baseCurrency(getFloat(value))} ${CURRENCY_SYMBOLS[currencyId].text}`;
            } else {
                return `${baseCurrency(getFloat(value))} ${currencyId}`;
            }
        } catch (error) {
            return `${baseCurrency(getFloat(value))} ${currencyId}`;
        }
    }
};